import { doc, getDoc, getDocs, setDoc, deleteDoc, updateDoc, collection, query, where } from "firebase/firestore";
import { db } from "../firebase";

// Find registered client UID by email from "client" collection
const findClientUidByEmail = async (email) => {
  if (!email) return null;
  try {
    const clientQuery = query(
      collection(db, "client"),
      where("email", "==", email)
    );
    const snapshot = await getDocs(clientQuery);
    if (!snapshot.empty) {
      return snapshot.docs[0].id;
    }
  } catch (error) {
    console.error("Error finding client by email:", error);
  }
  return null;
};

// Get client UID from a contact ID (looks up contact email, then finds registered client)
const getClientUidFromContactId = async (contactId) => {
  if (!contactId) return null;
  try {
    const contactDoc = await getDoc(doc(db, "clients", contactId));
    if (!contactDoc.exists()) return null;

    const contactEmail = contactDoc.data().email;
    if (!contactEmail) return null;

    return await findClientUidByEmail(contactEmail);
  } catch (error) {
    console.error("Error getting client UID from contact:", error);
    return null;
  }
};

// Sync expense data to client's sharedExpenses collection
export const syncExpenseToClient = async (contactId, expenseData, expenseId, lawyerUid, lawyerName) => {
  if (!contactId) return;
  try {
    const clientUid = await getClientUidFromContactId(contactId);
    if (!clientUid) return;

    const sharedExpenseRef = doc(db, "client", clientUid, "sharedExpenses", expenseId);
    await setDoc(sharedExpenseRef, {
      ...expenseData,
      sharedBy: lawyerUid,
      sharedByName: lawyerName,
      sharedAt: new Date().toISOString(),
      originalExpenseId: expenseId,
    });
    console.log("Expense synced to client:", clientUid);
  } catch (error) {
    console.error("Error syncing expense to client:", error);
  }
};

// Update synced expense in client's sharedExpenses
export const reSyncExpenseToClient = async (contactId, expenseData, expenseId, lawyerUid, lawyerName) => {
  if (!contactId) return;
  try {
    const clientUid = await getClientUidFromContactId(contactId);
    if (!clientUid) return;

    const sharedExpenseRef = doc(db, "client", clientUid, "sharedExpenses", expenseId);
    await setDoc(sharedExpenseRef, {
      ...expenseData,
      sharedBy: lawyerUid,
      sharedByName: lawyerName,
      sharedAt: new Date().toISOString(),
      originalExpenseId: expenseId,
    });
    console.log("Expense re-synced to client:", clientUid);
  } catch (error) {
    console.error("Error re-syncing expense to client:", error);
  }
};

// Delete synced expense from client's sharedExpenses
export const deleteSyncedExpense = async (contactId, expenseId) => {
  if (!contactId) return;
  try {
    const clientUid = await getClientUidFromContactId(contactId);
    if (!clientUid) return;

    await deleteDoc(doc(db, "client", clientUid, "sharedExpenses", expenseId));
    console.log("Synced expense deleted from client:", clientUid);
  } catch (error) {
    console.error("Error deleting synced expense:", error);
  }
};
